import {akitaDevtools} from "@datorama/akita"
import BootstrapWeb from "app/WebController/BootstrapWeb"
import Logger from "logger/logger"
import React from 'react'
import ReactDOM from 'react-dom'
import {isDev} from "utils/isDev"

if (isDev())
  akitaDevtools()

Logger('EntryPoint.index', 'Start react render')

ReactDOM.render(
  <React.StrictMode>
    <BootstrapWeb/>
  </React.StrictMode>,
  document.getElementById(process.env.ROOT_ID ?? 'master')
)
